/* @flow */
import * as React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import DialogContent from 'components/DialogContent.jsx';

import './styles/JoinPageLoadingIndicator.scss';

class JoinPageLoadingIndicator extends React.Component<{}> {
  render() {
    return (
      <DialogContent className="JoinPageLoadingIndicator" onRequestHide={() => {}}>
        <BoxBody divided={false}>
          <LoadingIndicator />
        </BoxBody>
      </DialogContent>
    );
  }
}

export default JoinPageLoadingIndicator;
